<template>
  <div id="app">
    <header class="header">
      <nav class="navigation content">
        <router-link to="/">
          <img src="/static/img/logo.svg" alt="Logo" class="logo">
        </router-link>
        <div class="hamburger-ico">
          <span class="ham-rect"></span>
          <span class="ham-rect"></span>
          <span class="ham-rect"></span>
        </div>
        <div class="menu">
          <ul class="menu-items">
            <li class="mobile-only"><router-link to="/">Home</router-link></li>
            <li><router-link to="/projects">Projects</router-link></li>
            <!-- <li><router-link to="/contact">Contact</router-link></li> -->
          </ul>
        </div>
      </nav>
    </header>
    <router-view id="page-content" :key="$route.fullPath"/>
    <footer class="footer content">
      <div class="col">
        <h1>Site Map</h1>
        <ul class="ul bland-list">
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/projects">Projects</router-link></li>
          <!-- <li><router-link to="/contact">Contact</router-link></li> -->
        </ul>
      </div>
      <div class="col col-2">
        <img class="myself" src="/static/img/template_footer_me.jpg" alt="Picture of Thomas Hunter">
        A student of Computer Science at De Montfort University. Hobbies in programming and electronics. With interests
        in Android, PHP, JavaScript, MySQL.
      </div>
    </footer>
  </div>
</template>

<script>
import NavBar from './class/NavBar';

let navBar = null;

export default {
  name: 'app',
  mounted() {
    navBar = new NavBar(document.querySelector('.header .navigation'));
  },
  beforeDestroy() {
    if (navBar !== null) {
      navBar.closeMobileNavBar();
    }
  },
  watch: {
    '$route'(to, from) {
      if (navBar !== null) {
        navBar.closeMobileNavBar();
      }
    }
  }
};
</script>

<style lang="scss" src="./assets/scss/app.scss"></style>


// WEBPACK FOOTER //
// src/App.vue